import React from "react";

import LogoBox from "./LogoBox";
import NavBar from "./NavBar";

function MainView({ children, logo, design, screen, navbar }) {
  return (
    <main
      className={`min-h-screen w-full bg-retro-milk ${
        design &&
        "pb-32 bg-retro-sparkle-line bg-no-repeat bg-[length:300%_250px] sm:bg-[length:100%_250px] bg-[right_bottom_-110px] sm:bg-[right_bottom_-120px] xl:bg-[right_bottom_-110px] "
      }`}
    >
      {/* Navigation Bar */}
      {navbar && <NavBar />}

      {/* Main View */}
      <section
        className={`${
          screen && navbar
            ? "h-[calc(100vh_-_56px)]"
            : screen
            ? `${design ? "h-[calc(100vh_-_128px)]" : "h-screen"}`
            : "h-full"
        }`}
      >

        {/* Logo Box */}
        {logo && <LogoBox />}

        {/* Main Content */}
        {children}
      </section>
    </main>
  );
}

MainView.defaultProps = {
  logo: true,
  navbar: true,
  design: true,
  screen: false,
  error: false,
};

export default MainView;
